import { call, put } from "redux-saga/effects";
import {
  acceptDomiciliationBanqueApi,
  AuthentificationApi,
  downloadTiApi,
  downloadTiDocumentApi,
  downloadTiFactureDocumentApi,
  fetchKpiTiApi,
  getBanqueApi,
  getCategoriesApi,
  getEtatsApi,
  getHistoriqueApi,
  getLocalitesApi,
  getModeReglementApi,
  getReponseDomiciliationBanqueDataApi,
  getStatusModifApi,
  getTiApurementApi,
  getTiByIdApi,
  getTiColumnsDensityStateApi,
  getTiDecisionTypeMCEApi,
  getTiDecisionTypeMCEProlongApi,
  getTiDepartmentsApi,
  getTypeMessageApi,
  getTypeReglementApi,
  getTypeTEApi,
  getTypeTIApi,
  postChangePasswordApi,
  postDonnesReglementsApi,
  postTiColumnsDensityStateApi,
  refuseDomiciliationBanqueApi,
  registerMFAApi,
  searchDeclarantsApi,
  searchGuichetsApi,
  searchImportateursApi,
  searchNomenclaturesApi,
  searchTitresApi,
  sendOtpMailApi,
  TiDecisionDEPApi,
  TiDecisionMCEApi,
  TiProlongDEPApi,
  TiProlongMCEApi,
  transferTiApi,
  transferTiProlongApi,
} from "../../../common/services/api/TiApi";
import { preparePayloadEtatTable } from "../../../common/utils/FunctionsUtils";
import * as actions from "../state/TiActions";

export function* searchTitresSaga(payload) {
  try {
    const response = yield call(searchTitresApi, payload);
    yield put(actions.searchTitresSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.searchTitresFailure(err));
  }
}

export function* searchGuichetsSaga(payload) {
  try {
    const response = yield call(searchGuichetsApi, payload);

    yield put(actions.getTiGuichetsSuccess(response?.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiGuichetsFailure(err));
  }
}

export function* searchImportateursSaga(payload) {
  try {
    const response = yield call(searchImportateursApi, payload);
    yield put(actions.getTiImportateursSuccess(response?.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiImportateursFailure(err));
  }
}

export function* searchNomenclaturesSaga(payload) {
  try {
    const response = yield call(searchNomenclaturesApi, payload);
    yield put(actions.getTiNomenclaturesSuccess(response?.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiNomenclaturesFailure(err));
  }
}

export function* searchDeclarantsSaga(payload) {
  try {
    const response = yield call(searchDeclarantsApi, payload);
    yield put(actions.getTiDeclarantsSuccess(response?.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiDeclarantsFailure(err));
  }
}

export function* getTiEtatsSaga() {
  try {
    const response = yield call(getEtatsApi);
    yield put(actions.getTiEtatsSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiEtatsFailure(err));
  }
}

export function* getTiLocalitesSaga() {
  try {
    const response = yield call(getLocalitesApi);
    yield put(actions.getTiLocalitesSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiLocalitesFailure(err));
  }
}

export function* getTiCategoriesSaga() {
  try {
    const response = yield call(getCategoriesApi);
    yield put(actions.getTiCategoriesSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiCategoriesFailure(err));
  }
}

export function* getTiStatusModifSaga() {
  try {
    const response = yield call(getStatusModifApi);
    yield put(actions.getTiStatusModifSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiStatusModifFailure(err));
  }
}

export function* getTiTypeMessageSaga() {
  try {
    const response = yield call(getTypeMessageApi);
    yield put(actions.getTiTypeMessageSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiTypeMessageFailure(err));
  }
}

export function* getTiBanqueSaga() {
  try {
    const response = yield call(getBanqueApi);
    yield put(actions.getTiBanqueSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiBanqueFailure(err));
  }
}

export function* getTypeReglementSaga() {
  try {
    const response = yield call(getTypeReglementApi);
    yield put(actions.getTypeReglementSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTypeReglementFailure(err));
  }
}

export function* getModeReglementSaga() {
  try {
    const response = yield call(getModeReglementApi);
    yield put(actions.getModeReglementSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getModeReglementFailure(err));
  }
}

export function* getTiApurementSaga() {
  try {
    const response = yield call(getTiApurementApi);
    yield put(actions.getTiApurementSuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiApurementFailure(err));
  }
}

export function* getTiTypeTESaga() {
  try {
    const response = yield call(getTypeTEApi);
    yield put(actions.getTiTypeTESuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiTypeTEFailure(err));
  }
}

export function* getTiTypeTISaga() {
  try {
    const response = yield call(getTypeTIApi);
    yield put(actions.getTiTypeTISuccess(response?.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiTypeTIFailure(err));
  }
}

export function* searchAllTitresSaga(payload) {
  try {
    payload = {
      ...payload,
      searchObject: {
        ...payload.searchObject,
        pagination: {
          ...payload.searchObject.pagination,
          pageSize: 1000,
        },
      },
    };

    const response = yield call(searchTitresApi, payload);
    yield put(actions.searchAllTitresSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.searchAllTitresFailure(err));
  }
}

export function* getTiByIdSaga(payload) {
  let mode = payload?.mode;
  try {
    const response = yield call(getTiByIdApi, payload);
    let data = response?.data?.content;
    let selectedDep = [];
    let MCE = null;
    let decisionMce = null;
    let canChangeDecision = true;

    if (mode === "GESTION" || mode === "GESTION_DEP") {
      MCE = data?.departementsMCE;
    } else if (mode === "PROLONGATION") {
      MCE = data?.departementsProlongationMCE;
    }
    const transformedDeps = MCE?.map((item) => ({
      id: item.departement.id,
      description: item.departement.description,
      code: item.departement.code,
      visible: item.departement.visible,
      dfd: item.departement.dfd,
    }));
    selectedDep = transformedDeps;
    data.selectedDep = selectedDep;

    canChangeDecision =
      data?.decisionMce?.id === 1 || data?.decisionMce === null;

    if (!canChangeDecision) {
      decisionMce = data?.decisionMce?.id;
    }
    data.fixedDecision = decisionMce;
    data.canTakeDecision = canChangeDecision;
    yield put(actions.getTiSuccess(data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiFailure(err));
  }
}

export function* downloadTiSaga(payload) {
  try {
    const response = yield call(downloadTiApi, payload);
    yield put(actions.downloadTiSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.downloadTiFailure(err));
  }
}

export function* downloadTiFactureDocumentSaga(payload) {
  try {
    const response = yield call(downloadTiFactureDocumentApi, payload);
    const data = response?.data?.content || "DOWNLOAD";
    yield put(actions.downloadTiFactureDocumentSuccess(data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.downloadTiFactureDocumentFailure(err));
  }
}

export function* downloadTiDocumentSaga(payload) {
  try {
    const response = yield call(downloadTiDocumentApi, payload);
    const data = response?.data?.content || "DOWNLOAD";
    yield put(actions.downloadTiDocumentSuccess(data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.downloadTiDocumentFailure(err));
  }
}

export function* fetchTiHistoriqueSaga(id) {
  try {
    const response = yield call(getHistoriqueApi, id);
    yield put(actions.fetchTiHistoriqueSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.fetchTiHistoriqueFailure(err));
  }
}

export function* getTiDepartmentsSaga() {
  try {
    const response = yield call(getTiDepartmentsApi);
    yield put(actions.getTiDepartmentsSuccess(response.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiDepartmentsFailure(err));
  }
}

export function* transferTiSaga(payload) {
  try {
    const response = yield call(transferTiApi, payload);
    yield put(actions.transferTiSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.transferTiFailure(err));
  }
}

export function* transferTiProlongSaga(payload) {
  try {
    const response = yield call(transferTiProlongApi, payload);
    yield put(actions.transferTiProlongSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.transferTiProlongFailure(err));
  }
}

export function* getTiDecisionTypeMCESaga() {
  try {
    const response = yield call(getTiDecisionTypeMCEApi);
    yield put(actions.getTiDecisionTypeMCESuccess(response.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiDecisionTypeMCEFailure(err));
  }
}

export function* TiDecisionMCESaga(payload) {
  try {
    const response = yield call(TiDecisionMCEApi, payload);
    yield put(actions.postTiDecisionMCESuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.postTiDecisionMCEFailure(err));
  }
}

export function* TiDecisionDEPSaga(payload) {
  try {
    const response = yield call(TiDecisionDEPApi, payload);
    yield put(actions.postTiDecisionDEPSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.postTiDecisionDEPFailure(err));
  }
}

export function* getTiDecisionTypeMCEProlongSaga() {
  try {
    const response = yield call(getTiDecisionTypeMCEProlongApi);
    yield put(
      actions.getTiDecisionTypeMCEProlongSuccess(response.data?.content)
    );
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiDecisionTypeMCEProlongFailure(err));
  }
}

export function* TiProlongMCESaga(payload) {
  try {
    const response = yield call(TiProlongMCEApi, payload);
    yield put(actions.postTiProlongMCESuccess(response.data?.content));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.postTiProlongMCEFailure(err));
  }
}

export function* TiProlongDEPSaga(payload) {
  try {
    const response = yield call(TiProlongDEPApi, payload);
    yield put(actions.postTiProlongDEPSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.postTiProlongDEPFailure(err));
  }
}

export function* postTiColumnsDensityStateSaga(payload) {
  try {
    const data = preparePayloadEtatTable(
      payload.data.columnsState,
      payload.data.density,
      "BNK/TI"
    );

    const response = yield call(postTiColumnsDensityStateApi, data);
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
  }
}

export function* getTiColumnsDensityStateSaga() {
  try {
    const response = yield call(getTiColumnsDensityStateApi);
    const { id, activatedField, density } = response.data;
    if (response.data && response.data !== null && id !== null) {
      let activatedFieldsArray = [""];
      if (activatedField !== null) {
        activatedFieldsArray = activatedField.split(",");
      }
      const allFields = {
        dateCreation: false,
        dateDomiciliation: false,
        categorie: false,
        devise: false,
        montant: false,
        importateur: false,
        declarant: false,
        etat: false,
      };

      activatedFieldsArray.forEach((field) => {
        if (allFields.hasOwnProperty(field)) {
          allFields[field] = true;
        }
      });

      const newData = {
        id: id,
        columnsState: allFields,
        density: density || "standard",
      };

      yield put(actions.getTiColumnsDensityStateSuccess(newData));
    } else {
      const newData = null;
      yield put(actions.getTiColumnsDensityStateSuccess(newData));
    }
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.getTiColumnsDensityStateFailure(err));
  }
}

export function* fetchKpiTiSaga(payload) {
  try {
    const response = yield call(fetchKpiTiApi, payload);
    yield put(actions.fetchKpiTiSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.fetchKpiTiFailure(err));
  }
}

export function* authenticateSaga(payload) {
  try {
    const response = yield call(AuthentificationApi, payload);
    yield put(actions.authenticateSuccess(response?.data));
  } catch (error) {
    yield put(actions.authenticateFailure(error));
  }
}

export function* registerMFASaga(payload) {
  try {
    const response = yield call(registerMFAApi, payload);
    yield put(actions.registerMFASuccess(response?.data));
  } catch (error) {
    yield put(actions.registerMFAFailure(error));
  }
}

export function* sendOtpMailSaga(payload) {
  try {
    const response = yield call(sendOtpMailApi, payload);
    yield put(actions.sendOtpMailSuccess(response?.data));
  } catch (error) {
    yield put(actions.sendOtpMailFailure(error));
  }
}

export function* postChangePasswordSaga(payload) {
  const response = yield call(postChangePasswordApi, payload);
  if (response.success) {
    yield put(actions.postChangePasswordSuccess(response?.data?.message));
  } else {
    yield put(actions.postChangePasswordFailure(response?.error?.message));
  }
}

export function* getReponseDomiciliationBanqueDataSaga({ payload }) {
  try {
    const response = yield call(getReponseDomiciliationBanqueDataApi, payload);
    yield put(actions.getReponseDomiciliationBanqueDataSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(
      actions.getReponseDomiciliationBanqueDataFail(error.response?.data)
    );
  }
}
export function* acceptDomiciliationBanqueSaga({ payload, callback }) {
  try {
    const response = yield call(acceptDomiciliationBanqueApi, payload);
    yield put(actions.acceptDomiciliationBanqueSuccess(response.data));

    if (callback && typeof callback === "function") {
      yield call(callback);
    }
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.acceptDomiciliationBanqueFail(error.response?.data));
  }
}
export function* refuseDomiciliationBanqueSaga({ payload, callback }) {
  try {
    const response = yield call(refuseDomiciliationBanqueApi, payload);
    yield put(actions.refuseDomiciliationBanqueSuccess(response.data));

    if (callback && typeof callback === "function") {
      yield call(callback);
    }
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.refuseDomiciliationBanqueFail(error.response?.data));
  }
}

export function* postDonnesReglementsSaga(payload) {
  try {
    const response = yield call(postDonnesReglementsApi, payload);
    yield put(actions.postDonnesReglementsSuccess(response.data));
  } catch (error) {
    let err = "Une erreur s'est produite, merci de ressayer plus tard";
    if (!!error?.response?.data?.message) {
      err = error?.response?.data?.message;
    } else {
      if (!!error?.response?.data?.error) {
        err = error?.response?.data?.error;
      }
    }
    yield put(actions.postDonnesReglementsFailure(err));
  }
}
